import { isFillAlignToWidth } from "common/util/image/image_dimensions";
import { useImageDimensions } from "hooks/hook_util/image/dimensions/useImageDimensions";
import styled from "styled-components";

type Props = {
  src: string;
  alt: string;
  width: number;
  height: number;
};

const PhotoFill = ({ src, alt, width, height }: Props) => {
  const { isLoading, dimensions, handleLoad, handleError } =
    useImageDimensions(src);

  return (
    <>
      <DivAlbumLiPhoto width={width} height={height}>
        <Img
          src={src}
          alt={alt}
          onLoad={handleLoad}
          onError={handleError}
          fillAlignToWidth={
            dimensions
              ? isFillAlignToWidth(dimensions, { width, height })
              : false
          }
          width={width}
          height={height}
        />
      </DivAlbumLiPhoto>
    </>
  );
};

const Img = styled.img<{
  fillAlignToWidth?: boolean;
  width: number;
  height: number;
}>`
  display: flex;
  width: ${(props) => (props.fillAlignToWidth ? props.width + "px" : "auto")};
  height: ${(props) => (!props.fillAlignToWidth ? props.width + "px" : "auto")};
  overflow: hidden;
`;

const DivAlbumLiPhoto = styled.div<{ width: number; height: number }>`
  display: flex;
  margin-top: 0;
  width: ${(props) => props.width + "px"};
  height: ${(props) => props.height + "px"};
`;

export default PhotoFill;
